/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Loading_OrgsInputs */

const th_loading_orgs = /** @type {(inputs: Loading_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังโหลดองค์กร…`)
};

const en_loading_orgs = /** @type {(inputs: Loading_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading organisations…`)
};

const ja_loading_orgs = /** @type {(inputs: Loading_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`団体を読み込んでいます…`)
};

const zh_loading_orgs = /** @type {(inputs: Loading_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在加载组织…`)
};

const es_loading_orgs = /** @type {(inputs: Loading_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando organizaciones…`)
};

const pt_loading_orgs = /** @type {(inputs: Loading_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando organizações…`)
};

const id_loading_orgs = /** @type {(inputs: Loading_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memuat organisasi…`)
};

const fr_loading_orgs = /** @type {(inputs: Loading_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement des organisations…`)
};

const tl_loading_orgs = /** @type {(inputs: Loading_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nilo-load ang mga organisasyon…`)
};

const vi_loading_orgs = /** @type {(inputs: Loading_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang tải tổ chức…`)
};

const ko_loading_orgs = /** @type {(inputs: Loading_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`조직을 불러오는 중…`)
};

const de_loading_orgs = /** @type {(inputs: Loading_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organisationen werden geladen…`)
};

const ru_loading_orgs = /** @type {(inputs: Loading_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загружаем организации…`)
};

const tr_loading_orgs = /** @type {(inputs: Loading_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuruluşlar yükleniyor…`)
};

const it_loading_orgs = /** @type {(inputs: Loading_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento organizzazioni…`)
};

const pl_loading_orgs = /** @type {(inputs: Loading_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wczytywanie organizacji…`)
};

const uk_loading_orgs = /** @type {(inputs: Loading_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Завантажуємо організації…`)
};

const hi_loading_orgs = /** @type {(inputs: Loading_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संगठन लोड हो रहे हैं…`)
};

const ar_loading_orgs = /** @type {(inputs: Loading_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جارٍ تحميل المؤسسات…`)
};

const ms_loading_orgs = /** @type {(inputs: Loading_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memuat organisasi…`)
};

const bn_loading_orgs = /** @type {(inputs: Loading_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সংস্থা লোড হচ্ছে…`)
};

const zh_tw2_loading_orgs = /** @type {(inputs: Loading_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在載入組織…`)
};

const zh_hk2_loading_orgs = /** @type {(inputs: Loading_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在載入組織…`)
};

const ur_loading_orgs = /** @type {(inputs: Loading_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ادارے لوڈ ہو رہے ہیں…`)
};

const fa_loading_orgs = /** @type {(inputs: Loading_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`در حال بارگذاری سازمان‌ها…`)
};

const sw_loading_orgs = /** @type {(inputs: Loading_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inapakia mashirika…`)
};

const nl_loading_orgs = /** @type {(inputs: Loading_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organisaties laden…`)
};

/**
* | output |
* | --- |
* | "Loading organisations…" |
*
* @param {Loading_OrgsInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const loading_orgs = /** @type {((inputs?: Loading_OrgsInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loading_OrgsInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_loading_orgs(inputs)
	if (locale === "ja") return ja_loading_orgs(inputs)
	if (locale === "zh") return zh_loading_orgs(inputs)
	if (locale === "es") return es_loading_orgs(inputs)
	if (locale === "pt") return pt_loading_orgs(inputs)
	if (locale === "id") return id_loading_orgs(inputs)
	if (locale === "fr") return fr_loading_orgs(inputs)
	if (locale === "tl") return tl_loading_orgs(inputs)
	if (locale === "vi") return vi_loading_orgs(inputs)
	if (locale === "ko") return ko_loading_orgs(inputs)
	if (locale === "de") return de_loading_orgs(inputs)
	if (locale === "ru") return ru_loading_orgs(inputs)
	if (locale === "tr") return tr_loading_orgs(inputs)
	if (locale === "it") return it_loading_orgs(inputs)
	if (locale === "pl") return pl_loading_orgs(inputs)
	if (locale === "uk") return uk_loading_orgs(inputs)
	if (locale === "hi") return hi_loading_orgs(inputs)
	if (locale === "ar") return ar_loading_orgs(inputs)
	if (locale === "ms") return ms_loading_orgs(inputs)
	if (locale === "bn") return bn_loading_orgs(inputs)
	if (locale === "zh-TW") return zh_tw2_loading_orgs(inputs)
	if (locale === "zh-HK") return zh_hk2_loading_orgs(inputs)
	if (locale === "ur") return ur_loading_orgs(inputs)
	if (locale === "fa") return fa_loading_orgs(inputs)
	if (locale === "sw") return sw_loading_orgs(inputs)
	if (locale === "nl") return nl_loading_orgs(inputs)
	return en_loading_orgs(inputs)
});